import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

const getRatingAccessorials = (searchFilter: string) => {
  return axiosInstance.request({
    method: 'get',
    params: { searchFilter },
    url: `${API.SPOT_QUOTE_V2}/options/accessorials`,
  });
};

export type RatingAccessorialsListItem = {
  codeId: string;
  codeDesc: string;
  value1: string;
  value2: string;
  value3: string;
  string1: string;
  string2: string;
  string3: string;
};

export type RatingAccessorialsListResponse = RatingAccessorialsListItem[];

export const fetchRatingAccessorialsList = async (searchFilter: string): Promise<RatingAccessorialsListResponse> => {
  const response: AxiosResponse<RatingAccessorialsListResponse> = await getRatingAccessorials(searchFilter);

  return response.data;
};
